// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"e16a4d8a","227":"cc374199","268":"2c9bb9f5","761":"85d2d082","787":"e6685882","836":"ebef3c46"}[chunkId] + ".chunk.js";
};